<template>
  <div class="basic-setting-content pl16 pr16" v-loading="loading">
    <!--基本信息-->
    <div class="common-form">字帖信息</div>
    <el-form-item label="字帖名称：" :rules="[{ required: true, message: '请填写名称' }]" prop="model.productName">
      <el-input v-model="form.model.productName" class="max-w460"></el-input>
    </el-form-item>
<!--    <el-form-item label="字帖编码："><el-input v-model="form.model.productNo" class="max-w460"></el-input></el-form-item>-->
    <el-form-item label="所属分类：" :rules="[{ required: true, message: '请选择字帖分类' }]" prop="model.categoryId">
      <wlTreeSelect   leaf width="240"  :leaf="true" :checkbox="false" :data=form.category @change="hindleChanged"  v-model="selected">
      </wlTreeSelect>





    </el-form-item>
    <el-form-item label="销售状态：" style="display: none;">
      <el-radio-group v-model="form.model.productStatus">
        <el-radio :label="10">立即上架</el-radio>
<!--        <el-radio :label="20">放入仓库</el-radio>-->
      </el-radio-group>
    </el-form-item>
    <el-form-item label="字帖图片：" :rules="[{ required: true, message: '请上传字帖图片' }]" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div  v-for="(item, index) in form.model.image" :key="item.filePath">
             <div class="item">
              <img v-img-imageId="item.fileId"  v-img-url="item.filePath"/>

              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>

             </div>

              <a v-if="item.videoId!=0 && item.videoId" target="_blank"  :href="item.videoFile" ><i>查看视频</i></a>
              <a style="margin-left: 10px" v-if="item.videoId!=0 && item.videoId"  v-id="item.fileId" href="javascript:void(0);"  @click.stop="openProductUpload('video', 'video',index)" ><i>修改视频</i></a>
              <a  v-else  v-id="item.fileId" href="javascript:void(0);"  @click.stop="openProductUpload('video', 'video',index)"><i>绑定视频</i></a>

            </div>

          </transition-group>
        </draggable>

        <div class="item img-select" @click="openProductUpload('image', 'image',0)"><i class="el-icon-plus"></i></div>

      </div>
    </el-form-item>
<!--    <el-form-item label="字帖封面：">-->
<!--      <el-row>-->
<!--        <div class="draggable-list">-->
<!--          <div class="item img-select" v-if="form.model.posterId==0" @click="openProductUpload('image', 'poster')"><i class="el-icon-plus"></i></div>-->
<!--          <div v-if="form.model.posterId!=0" class="item" @click="openProductUpload('image', 'poster')">-->
<!--            <img :src="form.model.posterFilePath" width="100" height="100" />-->
<!--          </div>-->
<!--        </div>-->
<!--      </el-row>-->
<!--    </el-form-item>-->

    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>

import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
        loading: false,
      value: [], // 选中值
      selectValue:[],
      selected: [ '14' ],// 树下拉框选中数据

      isProductUpload: false,
      config: {},
      file_name: 'image',
      activIndex:0,
    };
  },
  inject: ['form'],
  created() {

    if(this.form.model.categoryId!=null){
       this.selected=[{name:this.form.model.categoryName ,categoryId:this.form.model.categoryId}];
    }
this.reload();

  },
  mounted() {

    // console.log(this.form.category);
    // this.treeData=this.form.category;
    // console.log( this.treeData);

  },
  methods: {
    hindleChanged(val){
      if(val.length>0){
        this.form.model.categoryId=val[0].categoryId;
      }else{
        this.form.model.categoryId=null;

      }
      // this.selectValue=[{name:val[0].parentName,categoryId:val[0].categoryId}];
    },

    /*打开上传图片*/
    openProductUpload: function(file_type, file_name,activIndex) {
      // console.log("-----",activItem);
      this.file_name = file_name;
      if(file_type == 'image'){
        this.config = {
          total: 9,
          fileType: 'image'
        };
      }else{
        this.activIndex=activIndex;
        this.config = {
          total: 1,
          fileType: 'video'
        };
      }
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {

      console.log("e",e);
      if (e != null) {
        if(this.file_name == 'video'){
          this.form.model.videoId = e[0].fileId;
          this.form.model.videoFilePath = e[0].filePath;
          console.log("this.form.model",this.form.model);
          this.form.model.image[this.activIndex].videoFile=e[0].filePath;

          this.form.model.image[this.activIndex].videoId=e[0].fileId;


          console.log(this.form.model.image);

        }else if(this.file_name == 'image'){
          let imgs = this.form.model.image.concat(e);
          // 兼容后端
          for(let i=0;i<imgs.length;i++){
            if(typeof(imageId) == "undefined"){
              this.$set(imgs[i], 'imageId', imgs[i].imageId);
            }
          }
          this.$set(this.form.model, 'image', imgs);
        }else if(this.file_name == 'poster'){
          this.form.model.posterId = e[0].fileId;
          this.form.model.posterFilePath = e[0].filePath;
        }
      }


              this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.image.splice(index, 1);
    },
    delVideo(){
      this.form.model.videoId = 0;
      this.form.model.video = {};
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Basic.vue